export default "__VITE_ASSET__BOW5JPn6__"